import PropTypes from 'prop-types';

export const NotificationPropTypes = {
  notification: PropTypes.instanceOf(Object).isRequired,
};
